
export interface DocumentToggle {
  field: string;
  title: string;
  icon: string;
  iconColor: string;
  description: string;
  valueChange?: string;
}

export const classToggles: DocumentToggle[] = [
  {
    field: 'printQuotation',
    title: '¿Se imprime en Cotización?',
    icon: 'request_quote',
    iconColor: 'purple',
    description: '',
  },
  {
    field: 'printOrder',
    title: '¿Se imprime en Pedido?',
    icon: 'assignment',
    iconColor: 'purple',
    description: '',
  },
  {
    field: 'printDelivery',
    title: '¿Se imprime en Entrega?',
    icon: 'local_shipping',
    iconColor: 'purple',
    description: '',
  },
  {
    field: 'printInvoice',
    title: '¿Se imprime en Factura?',
    icon: 'receipt_long',
    iconColor: 'purple',
    description: '',
  },
  {
    field: 'removeLeadingZeros',
    title: 'Eliminar ceros a la izquierda de códigos en la impresión',
    icon: 'format_clear',
    iconColor: 'purple',
    description: '',
  },
];
